import { render } from "./ModalAdicionarGrupo.vue?vue&type=template&id=79792e64&scoped=true"
import script from "./ModalAdicionarGrupo.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarGrupo.vue?vue&type=script&lang=js"

import "./ModalAdicionarGrupo.vue?vue&type=style&index=0&id=79792e64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79792e64"]])

export default __exports__